<div class="page-container">
  <app-app-bar></app-app-bar>
  <div class="content-scroller">
    <div class="content-container">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
